//#region frontend/islands/shiny-tab.js
var ShinyTab = class extends HTMLElement {
	connectedCallback() {
		this._button = this.querySelector("button");
		if (this.hasAttribute("autoplay")) this._shimmer();
		else {
			this._onEnter = () => this._shimmer();
			this._button.addEventListener("mouseenter", this._onEnter);
		}
	}
	_shimmer() {
		const shimmer = document.createElement("span");
		shimmer.classList.add("shimmer");
		shimmer.style.animationDuration = "800ms";
		shimmer.style.animationDelay = "250ms";
		shimmer.style.animationFillMode = "both";
		shimmer.style.opacity = .2;
		this._button.appendChild(shimmer);
		setTimeout(() => shimmer.remove(), 1250);
	}
	disconnectedCallback() {
		this._button?.removeEventListener("mouseenter", this._onEnter);
	}
};
window.customElements.define("shiny-tab", ShinyTab);
//#endregion
